import React from "react";

function Projects() {
  return (
    <div className="bg-[#232323] text-white">
      <h1 className="font-kry text-center text-[4em] pt-20">Made By Me</h1>
      <div className="flex gap-12 mx-10 mt-20 pb-20 flex-row-reverse">
        <div>
          <a
            href="https://airbnb-yt-sage.vercel.app/"
            target="_blank"
            rel="noreferrer"
          >
            <p className="font-kry text-xl underline mb-6 hover:text-[#1BEEFF]">AirBnB Clone</p>
            <img className="hover:blur-sm" src="/images/AirP1.png" alt="" />
          </a>
        </div>
        <div className="mt-[60px]">
          <a
            href="https://starbucks-me.vercel.app/"
            target="_blank"
            rel="noreferrer"
          >
            <p className="font-kry text-xl underline mb-6 hover:text-[#1BEEFF]">StarBuck Clone</p>
            <img className="hover:blur-sm" src="/images/AirP2.png" alt="" />
          </a>
        </div>
        <div className="mt-[120px]" >
          <a
            href="http://portfolio-github-io-snowy.vercel.app/"
            target="_blank"
            rel="noreferrer"
          >
            <p className="font-kry text-xl underline mb-6 hover:text-[#1BEEFF]">My Portfolio</p>
            <img className="hover:blur-sm" src="/images/AirP3.png" alt="" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Projects;
